// extracted by mini-css-extract-plugin
export var iconEarphone = "pageTotal-module--iconEarphone--P8lHC";
export var iconGadio = "pageTotal-module--iconGadio--mEAIX";
export var iconDevice = "pageTotal-module--iconDevice--+LDJJ";
export var iconFace = "pageTotal-module--iconFace--gQZ7B";